module.exports = __webpack_public_path__ + "img/ib.d621c55a.svg";